export { AcceptScheduledTournamentScreen } from './AcceptScheduledTournamentScreen'
